import { getRelease } from './helpers';

const env = process.env;

const buildVersion = env.REACT_APP_CODEBUILD_BUILD_NUMBER;
const serverEnvironment = env.REACT_APP_SERVER_ENV;
const wafCaptcha = env.REACT_APP_WAF_API_URL;
const wafApiKey = env.REACT_APP_WAF_API_KEY;

const sentryDsn = env.REACT_APP_SENTRY_DSN;

export const Config = {
  /** Offline browser rehearsal; never set for a live POS release. */
  isIsolatedRehearsal: env.REACT_APP_ISOLATED_REHEARSAL === 'true',
  /** The current build version of the application. Available in the Cloud. */
  buildVersion,
  /** Describes the server environment (e.g., development, production). */
  serverEnvironment,
  /** URL for ops service. */
  opsURL: env.REACT_APP_OPS_URL!,
  /** Base URL for API. */
  baseURL: env.REACT_APP_BASE_URL!,
  /** URL for socket. */
  socketURL: env.REACT_APP_SOCKET_URL!,
  /** LogRocket app name */
  logRocketApp: env.REACT_APP_LOGROCKET_APP!,
  /** Encryption key for local storage values. */
  cryptoKey: env.REACT_APP_CRYPTO_KEY || 'secret',
  /** The API key used for Google Maps services. */
  googleMapsApiKey: env.REACT_APP_GOOGLE_MAPS_API_KEY,
  /** Auth clover API link */
  authCloverApiUrl: env.REACT_APP_AUTH_CLOVER_API_URL,
  /** Enables debugging of HTML/PDF content. */
  isDebugHTMLEnabled: env.REACT_APP_DEBUG_HTML === 'true',
  /** Sentry configuration. */
  sentry: {
    dsn: sentryDsn,
    ...getRelease(sentryDsn, serverEnvironment, buildVersion),
  },
  /** AWS WAF */
  waf: {
    apiKey: wafApiKey,
    apiUrl: wafCaptcha,
    enabled: !!wafCaptcha && !!wafApiKey,
  },
};
